<template>
    <section class="l--wrapper l-f--wrapper space-betw">
        <section class="m--wrapper flex-1">
            <router-view/>
            <section class="bin--top c--wrapper">
                <article class="h--article">
                    <h1 class='title--h1'>Welkom!</h1>
                    <p class="p--text">
                        Maak hier een nieuwe zangdienstlijst of iets dergelijks.
                    </p>
                </article>
                <div class="m--block h--flex--space" id="stand">
                    <h2 class="title--h2">
                        Maak een nieuw zangdienstlijst
                    </h2>
                    <router-link class="bgc--p--button a--button h--flex--center c--flex--center" to="/select-date">
                        Maak een nieuwe zangdienstlijst
                    </router-link>
                </div>
            </section>
        </section>
        <footer>
            &copy; 2020 | Made By <a href="https://arnoldfrancisca.com" target="_blank">Arnold</a>
        </footer>
    </section>
</template>

<script>

export default {
  name: 'home'
}
</script>
